<!-- Activator element -->
<div class="column-filter-activator" id="filterActivator"
  data-testid="shared-columnfilter-activator"
  (click)="$event.stopPropagation();updateFilterValues(); filterPopover.toggle($event)">
  <i class="pi {{ filterActive ? 'pi-filter-fill' : 'pi-filter' }} filter-col-icon" [class.active]="filterActive">
  </i>
</div>

<!-- Popover definition -->
<p-popover #filterPopover appendTo="body" styleClass="column-filter-panel" (onHide)="onFilterPanelHide()">

  <ng-template #content>
    <div class="filter-panel-content">
      <!-- Close icon -->
      <i class="pi pi-times close-btn" data-testid="shared-columnfilter-close-icon" (click)="filterPopover.hide()"></i>

      <!-- Header actions -->
      <div class="filter-header-actions">
        <button pButton pRipple severity="secondary" type="button"
          class="p-button-raised p-button-default p-button-sm clear-filter-btn" icon="pi pi-trash" iconPos="left"
          [attr.data-testid]="'shared-columnfilter-clear-button'"
          label="Clear filter from {{ displayName }}" (click)="clearFilter()">
        </button>
      </div>

      <!-- Filter listbox -->
      <div class="filter-selection-container">
        <!-- {{filterOptions|json}} -->
        <p-listbox #columnFilterListbox optionLabel="label" [options]="filterOptions"
          [(ngModel)]="selectedFilterOptions" [checkbox]="true" [multiple]="true" [filter]="true" [virtualScroll]="true"
          [virtualScrollItemSize]="34" class="column-filter-listbox" listclass="column-filter-list-items">

          <ng-template let-option pTemplate="item">
            <div class="option-label" [class.faded]="option.title == 0">
              {{ option.label }} ({{ option.title }})
            </div>
          </ng-template>
        </p-listbox>
      </div>

      <!-- Footer actions -->
      <div class="filter-actions">
        <div class="clear-all-link-btn" data-testid="shared-columnfilter-clearall-link" (click)="clearAllFilters()">Clear All Filters</div>
        <button pButton pRipple type="button" class="p-button-raised p-button-primary p-button-sm apply-filter-btn"
          [attr.data-testid]="'shared-columnfilter-apply-button'"
          label="Apply" (click)="applyFilter()">
        </button>
        <button pButton pRipple type="button" class="p-button-raised p-button-default p-button-sm close-filter-btn"
          [attr.data-testid]="'shared-columnfilter-cancel-button'"
          label="Cancel" (click)="filterPopover.hide()">
        </button>
      </div>
    </div>
  </ng-template>
</p-popover>